import './Scale.css'

const Scale = ({x, tickCount }) => {
    const ticks = x.ticks(tickCount)

    return ticks.map(value => [value, x(value)]).map(([value, position]) => (
        <g transform={`translate(${position})`} className={"scaleTick"}>
            <text
                y={14}
                textAnchor={"middle"}
            >
                {value}
            </text>
        </g>
    ))

}

export default Scale;
